import React from 'react';
import './video.css';

const Video = ({ videoId }) => {
    const src = `https://www.youtube.com/embed/${videoId}`;
    return (
        <section className="video-frame">
            <div className="video-responsive">
                <iframe
                    src={src}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
        </section>
    );
};

export default Video;
